var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"modal-button-close",class:[this.$route.params.lang],domProps:{"innerHTML":_vm._s(_vm.$t('btn.close'))},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }